import { timeFormat, format } from "d3";

const SMALL = 300;
const LARGE = 10000;

export function getDateFormatByCount(count: number) {
  if (count < SMALL) {
    return timeFormat("%b %d");
  }
  if (count < LARGE) {
    return timeFormat("%b %y");
  }
  return timeFormat("%Y");
}

export enum TickValueType {
  IntegersOnly,
}

export function getTicksFromValueTypes(scale: any, tickValueType?: TickValueType, tickCount?: number) {
  if (tickValueType === TickValueType.IntegersOnly) {
    return scale.ticks(tickCount).filter(Number.isInteger);
  }

  return null;
}

type Params = (domainValue: d3.AxisDomain, index: number) => string;
export function getFormatFromValueTypes(tickValueType: undefined): null;
export function getFormatFromValueTypes(tickValueType: TickValueType): Params;
export function getFormatFromValueTypes(tickValueType?: TickValueType): Params | null {
  // Use default d3 tick formatting
  if (tickValueType === undefined) {
    return null;
  }

  return function (axisValue: d3.AxisDomain): string {
    let currentString = axisValue.valueOf();
    if (tickValueType === TickValueType.IntegersOnly) {
      return (+currentString).toLocaleString();
    }

    return currentString.toLocaleString();
  };
}

const abbreviatedFormatter = format(".2~s");

/**
 * Formats a numeric axis tick value using an abbreviated SI-prefix (e.g., 100000 -> 100k, 1500000 -> 1.5m).
 * @param value - The axis tick value to format.
 * @returns The formatted string with an appropriate SI-prefix.
 */
export function formatAbbreviatedAxisTick(value: d3.AxisDomain): string {
  const num = +value;

  // For values less than 1, display as decimal to avoid milli/micro SI prefixes
  if (num < 1 && num !== 0) {
    return num.toString();
  }

  const formattedValue = abbreviatedFormatter(num);
  const suffix = formattedValue.slice(-1);
  if (!/[a-zA-Z]/.test(suffix)) {
    return formattedValue; // no magnitude suffix
  }
  const base = formattedValue.slice(0, -1);
  // Map SI suffixes to product-required lowercase set with 'b' for billions
  switch (suffix) {
    case "G":
      return `${base}b`; // billion
    default:
      return `${base}${suffix.toLowerCase()}`;
  }
}
